import React from 'react';
import ReactDOM from 'react-dom';

class VideoContainer extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      customVideoElementInserted: false,
      posterError: false
    };
    this.onPosterError = this.onPosterError.bind(this);
    this.onPosterLoaded = this.onPosterLoaded.bind(this);
  }

  componentDidMount() {
    this.insertVideoElement(this.props.video);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.video) return;
    // Set up video element
    let videoElement = this.props.video;
    if (!prevState.customVideoElementInserted && typeof this.props.video.getHTMLElement === 'function') {
      // The video is an instance of a class that provides a player
      // separately from the video itself: insert it.
      videoElement = this.props.video.getHTMLElement();
      this.setState({
        customVideoElementInserted: true
      });
    } else if (prevProps.video) return;
    this.insertVideoElement(videoElement);
  }

  insertVideoElement(videoElement) {
    if (!(videoElement instanceof HTMLElement)) return;
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    var videoNode = ReactDOM.findDOMNode(this.refs.video);
    videoNode.appendChild(videoElement);
  }

  onPosterError() {
    this.setState({
      posterError: true
    });
  }

  onPosterLoaded() {
    if (!this.state.posterError) return;
    this.setState({
      posterError: false
    });
  }

  render() {
    const { video, style, onClick, poster } = this.props;
    if (!video) return null;
    // Poster
    let posterClasses = 'poster fade ';
    posterClasses += video.scaleMode || 'aspectFit';
    posterClasses += !poster ? ' hidden' : '';
    const fadingPoster = (
      <img
        ref='poster'
        src={poster || ''}
        className={posterClasses}
        onLoad={this.onPosterLoaded}
        onError={this.onPosterError} />
    );

    return (
      <div ref='video' className='video-container' style={style}
        onMouseDown={onClick}
        onTouchEnd={onClick}>
        {fadingPoster}
      </div>
    );
  }
}

export default VideoContainer;
